import * as React from "react";
import { IUserInfo, IRoleModel } from "../models/IUserInfo";

export const InitUserInfo: IUserInfo = {
    username: "",
    organisationName: "",
    rolesGroupId: "",
    roles: [],
    organisationId: 0,
    clinicId: 0,
    organisationNumber: "",
    clinicNumber: "",
    clinicName: "",
    isRiskPotCareProvider: false,
    backOfficeRoleGroupId: "",
    showGdprInformation: false,
    municipalityId: 0,
    municipalityName: "",
    districtId: 0,
    districtName: ""
}

export const UserContext = React.createContext<IUserInfo>(InitUserInfo);

export const isInRole = (role: string, roles: IRoleModel[] | undefined) => {
    if (!roles) {
        return false;
    }
    return roles.some(r => r.authName === role);
};